import { render, staticRenderFns } from "./SortTableQuery.vue?vue&type=template&id=05bb2802&"
import script from "./SortTableQuery.vue?vue&type=script&lang=js&"
export * from "./SortTableQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bb2802')) {
      api.createRecord('05bb2802', component.options)
    } else {
      api.reload('05bb2802', component.options)
    }
    module.hot.accept("./SortTableQuery.vue?vue&type=template&id=05bb2802&", function () {
      api.rerender('05bb2802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/SortTableQuery.vue"
export default component.exports